
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/otmlar-royhati",
      function () {
        return require("private-next-pages/otmlar-royhati.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/otmlar-royhati"])
      });
    }
  